/**
 * @desc 列表
 */
const URL = "/rantion-basics";
import http, { updateResponse } from "@/http";
export type Response = defs.basics.ResponseDto<Array<defs.basics.ProductSkuModel>>;
export function request(
  body: defs.basics.ProductSkuRequestParamsDto,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/basics/productSku/list`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
